<sgt-select
  [options]="selectOptions"
  [settings]="selectSettings"
  [(ngModel)]="idReferencia"
  (ngModelChange)="onSelectionChange()"
  (selectedValueChanged)="onSearch()"
>
  <ng-template #customOptionTemplate let-option>
    <i *ngIf="option.icon" [class]="option.icon" class="mr-1"></i>
    <span>{{ option.label }}</span>
  </ng-template>
</sgt-select>
